import { css } from '@emotion/css';

export const modalHeading = css`
  font-size: 1rem;
  color: var(--color-neutral-70);
  font-weight: 500;
  line-height: 1.125rem;
`;

export const addedHoursText = css`
  font-size: 0.75rem;
  color: var(--color-primary-50);
  font-weight: 500;
  line-height: 1.125rem;
  font-size: 0.75rem;
  text-decoration: underline;
`;

export const addHoursText = css`
  font-size: 0.75rem;
  color: var(--color-warning-60);
  font-weight: 500;
  line-height: 1.125rem;
  font-size: 0.75rem;
  text-decoration: underline;
  cursor: pointer;
`;

export const styledHoursData = css`
  color: var(--color-neutral-60);
  font-weight: 400;
  line-height: 1.125rem;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const styledDrawer = css`
  padding: 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const styledAccordion = css`
  border-radius: 0.25rem;
  margin-bottom: 1rem;
`;

export const styledAccordionHeading = css`
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  min-height: 2.5rem !important;
  height: 2.25rem;
  margin-bottom: 0.5rem;
`;

export const styledAssignments = css`
  height: calc(100vh - 12rem);
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const drawerHeader = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.325rem;
  color: var(--color-neutral-90);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  border-bottom: 1px solid var(--color-neutral-20);
`;

export const infoText = css`
  display: flex;
  padding: 2px 0.5rem;
  justify-content: flex-start;
  width: fit-content;
  align-items: center;
  gap: 0.625rem;
  border-radius: 5px;
  background: var(--color-gold-20);
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.125rem;
  color: var(--color-gold-80);
`;

export const noScopeText = css`
  color: var(--color-primary-50);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
  letter-spacing: 0.06px;
  padding-left: 1.5rem;
  padding-top: 0.5rem;
`;

export const addNewScopeText = css`
  color: var(--color-primary-50);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
  letter-spacing: 0.06px;
  cursor: pointer;
`;

export const estimatorName = css`
  display: flex;
  align-items: center;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
  gap: 0.5rem;
`;

export const userScope = css`
  border-bottom: 1px solid var(--color-neutral-30);
  padding: 0.5rem 0 1rem 0;
`;

export const styledDotIcon = css`
  width: 0.75rem;
`;

export const estHoursText = css`
  padding-left: 1.5rem;
`;

export const completionTag = css`
  color: var(--color-primary-50);
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 0.875rem;
  background: var(--color-primary-background);
  padding: 0.625rem;
`;

export const addChecklistLink = css`
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  gap: 0.25rem;
  cursor: pointer;
`;

export const styledFlex = css`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;
`;

export const drawerHeaderLine = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const existingScopeItem = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.75rem;
  line-height: 1.125rem;
  padding-bottom: 0.5rem;
  margin-top: 0.5rem;
`;

export const styledFlexForCheckList = css`
  display: flex;
  gap: 0.5rem;
  align-items: start;
  cursor: pointer;
  flex-wrap: wrap;
  word-break: break-word;
  min-height: 1.125rem;
  flex: 0 1 50%;
  min-width: 0;
  justify-content: flex-start;
`;

export const styledFlexForCheckBox = css`
  display: flex;
  gap: 0.5rem;
  align-items: end;
  cursor: pointer;
  flex-wrap: wrap;
  word-break: break-word;
  min-height: 1.125rem;
  flex: 0 0 20%;
  min-width: 0;
  justify-content: flex-end;
`;

export const errorText = css`
  margin-left: 1.5rem;
  color: var(--color-error-60);
`;

export const markReviewed = css`
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  background: var(--color-success-20);
  padding: 2px 0.5rem;
  color: var(--color-success-70);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
`;

export const markCompleted = css`
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  padding: 2px 0.5rem;
  color: var(--color-primary-main);
  border: 1px solid var(--color-primary-main);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
`;

export const loader = css`
  margin-top: 50%;
`;
